import { useEffect } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container privacy-policy-heading">
        <Header />
        <header className="main-header-section">
          <div className="header-max-width-wrapper">
            <h1>Privacy Policy</h1>
            <p>Last Updated: 11 Feb 2026</p>
          </div>
        </header>

        <main className="document-container">
          <article className="policy-paper-card">
            <section className="policy-section">
              <h2>1. Introduction</h2>
              <p>
                Welcome to Ye Apni Gaadi ("we," "our," or "us"). We are
                committed to protecting your privacy. This Privacy Policy
                explains how we collect, use, store, and share your information
                when you use our mobile application and services. By using Ye
                Apni Gaadi, you consent to the data practices described in this
                policy.
              </p>
            </section>

            <section className="policy-section">
              <h2>2. Information We Collect</h2>
              <p>
                We collect specific data to facilitate ride booking, fleet
                management, and safety compliance.
              </p>

              <h3>A. Identity & Profile Data</h3>
              <ul>
                <li>
                  <strong>For Drivers/Operators:</strong> Name, Profile Photo,
                  Phone Number.
                </li>
                <li>
                  <strong>Government IDs (Encrypted):</strong> We collect PAN
                  Card, Aadhaar Card, Driving License (DL) for identity
                  verification and compliance.
                </li>
                <li>
                  <strong>For Companies/Corporate Clients:</strong> Company
                  Name, GSTIN (Goods and Services Tax Identification Number),
                  and authorized employee details.
                </li>
              </ul>

              <h3>B. Vehicle Information</h3>
              <p>
                Vehicle photos, Registration Certificate (RC), Pollution Under
                Control (PUC) certificate, Permit certificate, and Insurance
                certificate.
              </p>

              <h3>C. Location Data</h3>
              <p>
                We collect precise location data (GPS) from drivers and riders
                to facilitate the ride, track trip progress, and ensure safety.
                This includes background location access for drivers to track
                rides even when the app is minimized.
              </p>

              <h3>D. Communication Data</h3>
              <ul>
                <li>
                  <strong>Chat:</strong> We store chat logs between drivers and
                  riders on our secure proprietary servers for dispute
                  resolution and safety
                </li>
                <li>
                  <strong>Calls:</strong> We use third-party services (Agora and
                  Exotel) to facilitate calls. While we do not record the
                  content of calls unless specified for safety, call metadata
                  (logs of calls made) may be retained.
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>3. How We Use Information</h2>
              <ul>
                <li>
                  <strong>Service Provision:</strong> To connect riders with
                  drivers, manage fleet operations, and process transactions.
                </li>
                <li>
                  <strong>Verification:</strong> To verify the identity of
                  drivers and the validity of vehicles (using PAN, Aadhaar, DL,
                  RC, etc.) to ensure a safe platform.
                </li>
                <li>
                  <strong>Safety & Compliance:</strong> To monitor rides,
                  prevent fraud, and assist law enforcement in the event of a
                  mishap.
                </li>
                <li>
                  <strong>Corporate Booking:</strong> To share ride details with
                  the Company (employer) regarding rides booked for their
                  employees.
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Data Storage & Security</h2>
              <ul>
                <li>
                  <strong>Encryption:</strong> All sensitive personal documents
                  (PAN, Aadhaar, DL, Vehicle Documents) are stored in our
                  database in encrypted form.
                </li>
                <li>
                  <strong>Access Control:</strong> We do not sell your personal
                  data. Access to sensitive data is strictly restricted to
                  authorized internal personnel for operational and compliance
                  purposes only.
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>5. Data Sharing and Disclosure</h2>
              <p>
                We do not share your personal data with third parties for
                marketing purposes. We strictly share data in the following
                scenarios:
              </p>
              <ul>
                <li>
                  <strong>With the Employer (Corporate Rides):</strong> If a
                  ride is booked by a Company for an employee, ride details
                  (location, time, driver details) are shared with the Company.
                </li>
                <li>
                  <strong>With Third-Party Service Providers:</strong>
                  <ul>
                    <li>
                      <strong>Agora & Exotel:</strong> Used for in-app calling
                      and number masking. Phone numbers may be processed by
                      these providers to connect calls without revealing
                      personal numbers between parties (Proxy Calling).
                    </li>
                    <li>
                      <strong>Google Maps/Map Providers:</strong> Location data
                      is shared to provide navigation.
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Live Location Sharing:</strong> Riders have the option
                  to share their live location and driver details with
                  third-party contacts (friends/family) via the "Share Ride"
                  feature.
                </li>
                <li>
                  <strong>Legal Requirements:</strong> We may disclose your data
                  if required by law, court order, or government authority in
                  the event of an investigation or safety incident.
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>6. User Rights & Account Deletion</h2>
              <ul>
                <li>
                  <strong>Access & Correction:</strong> You may request access
                  to the data we hold about you or request corrections to your
                  profile by contacting support.
                </li>
                <li>
                  <strong>Deletion:</strong> You may request the deletion of
                  your account and associated data. However, we may retain
                  certain transaction and compliance records (such as ride
                  history and invoice data) for a period required by tax and
                  transport laws.
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>7. Contact Us</h2>
              <div className="contact-box-simple">
                <p>
                  <strong>Email:</strong> support@yeapnigaadi.com
                </p>
                <p>
                  <strong>Address:</strong> H.No. 618, Near Metro Pillar 42B,
                  Mundka, Delhi, 110041
                </p>
              </div>
            </section>
          </article>
        </main>
      </div>
      <Footer />
    </>
  );
}
